export default __webpack_public_path__ + "ed9b0461f3be7243930393f2968572b2.png";